import { cn } from "@/lib/utils";
import type { PipelineStatusVariant } from "@/lib/pipelineBoard";

const STATUS_CLASS: Record<PipelineStatusVariant, string> = {
  queued:
    "bg-[var(--color-bg-secondary)] text-[var(--color-text-secondary)] border-[var(--color-border-light)]",
  mapping: "bg-amber-50 text-amber-800 border-amber-200",
  validating: "bg-teal-50 text-teal-700 border-teal-200",
  errors: "bg-red-50 text-red-800 border-red-200",
  ready: "bg-emerald-50 text-emerald-800 border-emerald-200",
  published: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

const DOT_CLASS: Record<PipelineStatusVariant, string> = {
  queued: "bg-[var(--color-text-tertiary)]",
  mapping: "bg-amber-500",
  validating: "bg-teal-600",
  errors: "bg-red-600",
  ready: "bg-[var(--color-brand-primary)]",
  published: "bg-emerald-600",
};

export function PipelineStatusChip({
  label,
  variant,
}: {
  label: string;
  variant: PipelineStatusVariant;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-1.5 py-0 text-[9px] font-semibold",
        STATUS_CLASS[variant]
      )}
    >
      <span className={cn("h-1 w-1 rounded-full", DOT_CLASS[variant])} />
      {label}
    </span>
  );
}
